<!--
 * @Author: DQL
 * @Date: 2020-03-30 10:02:32
 * @LastEditors: LZL
 * @LastEditTime: 2021-05-06 16:23:25
 * @Description: 下载文件
 -->
<template>
  <el-dialog
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="下载"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        v-loading="loading"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-form-item
          class="u-mg-b-20"
        >
          <el-tag
            :type="time==0&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'success':'info'"
            :effect="time==0&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'dark':'plain'"
            style="margin-right: 20px;cursor: pointer;"
            @click="handleDateChange('day')"
          >
            最近一天
          </el-tag>
          <el-tag
            :type="time==7*24*3600*1000&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'success':'info'"
            :effect="time==7*24*3600*1000&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'dark':'plain'"
            style="margin-right: 20px;cursor: pointer;"
            @click="handleDateChange('week')"
          >
            最近一个星期
          </el-tag>
          <el-tag
            :type="month==1&&date==0&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'success':'info'"
            :effect="month==1&&date==0&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'dark':'plain'"
            style="margin-right: 20px;cursor: pointer;"
            @click="handleDateChange('month')"
          >
            最近一个月
          </el-tag>
          <el-tag
            :type="year==1&&month==0&&date==0&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'success':'info'"
            :effect="year==1&&month==0&&date==0&&fd.rqz==new Date(new Date().toLocaleDateString()).getTime()?'dark':'plain'"
            style="cursor: pointer;"
            @click="handleDateChange('year')"
          >
            最近一年
          </el-tag>
        </el-form-item>
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="导出日期起"
              prop="rqq"
            >
              <el-date-picker
                v-model="fd.rqq"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="导出日期止"
              prop="rqz"
            >
              <el-date-picker
                v-model="fd.rqz"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="success"
        @click="handleDownload()"
      >
        导出
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { logService } from './log.service';

export default {
  name: 'ExportDialog',
  data () {
    const validatorStartTime = (rule, value, callback) => {
      if (value > this.fd.rqz) {
        return callback(new Error('导出开始时间不能晚于导出结束时间'));
      } else {
        // 校验通过清除开始时间校验
        this.$refs.fd.clearValidate('rqz');
      }
      return callback();
    };
    const validatorEndTime = (rule, value, callback) => {
      if (value < this.fd.rqq) {
        return callback(new Error('导出结束时间不能早于导出开始时间'));
      } else {
        // 校验通过清除开始时间校验
        this.$refs.fd.clearValidate('rqq');
      }
      return callback();
    };
    return {
      loading: false, // 页面是否loading状态
      dialogShow: true, // 模态框dialog显示
      /* 表单参数 Start */
      fd: {
        rqq: new Date(new Date().toLocaleDateString()).setMonth((new Date().getMonth() - 1)), // 30天之前
        rqz: new Date(new Date().toLocaleDateString()).getTime() // 当天时间开始，即00：00：00
      },
      // 导出参数
      exportParams: {},
      /* 表单参数 End */
      /* 表单校验规则 Start */
      fdRules: {
        rqq: [
          this.$validUtils.required('开始时间'), { validator: validatorStartTime, trigger: ['blur', 'change'] }
        ],
        rqz: [
          this.$validUtils.required('结束时间'), { validator: validatorEndTime, trigger: ['blur', 'change'] }
        ]
      }
      /* 表单校验规则 End */
    };
  },
  computed: {
    // 获取导出时间间隔大小
    time () {
      return this.fd.rqz - this.fd.rqq;
    },
    date () {
      return new Date(this.fd.rqz).getDate() - new Date(this.fd.rqq).getDate();
    },
    year () {
      return new Date(this.fd.rqz).getFullYear() - new Date(this.fd.rqq).getFullYear();
    },
    month () {
      return new Date(this.fd.rqz).getMonth() - new Date(this.fd.rqq).getMonth();
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 根据选择的实际间隔计算开始时间点
     * @param {String} 时间间隔大小
     * @return {*}
     */
    handleDateChange (str) {
      if (str === 'day') {
        this.fd.rqz = new Date(new Date().toLocaleDateString()).getTime();
        this.fd.rqq = this.fd.rqz;
      }
      if (str === 'week') {
        this.fd.rqz = new Date(new Date().toLocaleDateString()).getTime();
        this.fd.rqq = new Date(new Date().toLocaleDateString()).setDate((new Date().getDate() - 7));
      }
      if (str === 'month') {
        this.fd.rqz = new Date(new Date().toLocaleDateString()).getTime();
        this.fd.rqq = new Date(new Date().toLocaleDateString()).setMonth((new Date().getMonth() - 1));
      }
      if (str === 'year') {
        this.fd.rqz = new Date(new Date().toLocaleDateString()).getTime();
        this.fd.rqq = new Date(new Date().toLocaleDateString()).setFullYear((new Date().getFullYear() - 1));
      }
    },
    /**
     * @description: 点击下载
     * @param {*}
     * @return {*}
     */
    handleDownload () {
      const _this = this;
      this.$refs.fd.validate(valid => {
        if (valid) {
          this.loading = true;

          /* 后台日期接收参数改为 Start */
          this.exportParams.cxrqqStr = this.fd.rqq;
          this.exportParams.cxrqzStr = this.fd.rqz;
          /* 后台日期接收参数改为 End */

          logService.export(this.exportParams)
            .then((rsp) => {
              const fileStream = rsp.data;
              const fileName = decodeURI(rsp.headers['content-disposition'].split('=')[1]);
              this.$HMUtil.downloadStreamFile(fileStream, fileName);
            })
            .catch(err => {
              console.error('下载日志出错', err);
            })
            .finally(() => {
              this.loading = false;
            });
          _this.closeDialog();
        }
      });
    }
  }
};
</script>
